import React, {useEffect, useState} from "react";
import {FormattedMessage, useIntl,} from "react-intl";
import Button from "../../../ui-components/Button";
import Modal from "../../../ui-components/Modal";
import { DeclineQuotationModalProps } from "./types";
import Checkbox from "@ui-components/Checkbox";
import {RadioGroup} from "@feature/quotations/decline-quotation-modal/radio-group";


export const DeclineQuotationModal = ({
  onConfirm,
  onDismiss,
  loading,
}: DeclineQuotationModalProps) => {

  // hooks
  const intl = useIntl();

  // state
  const [selected, setSelected]
    = useState<"request"|"drop">("request");
  const [message, setMessage] = useState("");

  useEffect(() => {
    // When the component mounts or the selected value changes, reset the message
    setMessage("");
  }, [selected]);

  return (
    // @ts-ignore
    <Modal onExit={onDismiss}>
      <div className="flex flex-col gap-8">
        <h1 className="text-2xl font-extrabold">
          <FormattedMessage id="decline_quotation" defaultMessage="Rifiuta preventivo"/>
        </h1>
        <RadioGroup
          id="options-group"
          options={[
            {
              value: "request",
              label: intl.formatMessage({
                id: "quotation_request_changes",
                defaultMessage: "Richiedi modifiche",
              }),
              description: intl.formatMessage({
                id: "quotation_request_changes_description",
                defaultMessage: "Selezione questa opzione se desideri richiedere modifiche al preventivo",
              }),
            },
            {
              value: "drop",
              label: intl.formatMessage({
                id: "quotation_decline",
                defaultMessage: "Rifiuta preventivo",
              }),
              description: intl.formatMessage({
                id: "quotation_decline_description",
                defaultMessage: "Seleziona questa opzione se non sei interessato a questo preventivo",
              }),
            },
          ]}
          selected={selected}
          onChange={setSelected}
          message={message}
          onMessageChange={setMessage}
        />
        <div className="w-full">
          <Button
            full
            onClick={() => {
              const strippedMessage = message.trim() || undefined;
              onConfirm(selected, strippedMessage);
            }}
            disabled={loading}
            submitting={loading}
          >
            <FormattedMessage id="confirm"/>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
